import styled, { css } from 'styled-components';

import CssTransition from '@telialt/common-css-transition/src';
import {
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const TotalPriceBlockWrapper = styled.dl<{ $isStickySummary?: boolean }>`
    display: flex;
    margin: 0;
    padding: 0;

    ${({ $isStickySummary }) => css`
        flex-direction: column;
        width: 100%;

        ${purpurMedia('lg')`
            align-items: ${$isStickySummary ? 'center' : ''};
            flex-direction: ${$isStickySummary ? 'row' : 'column'};
            width: auto;
        `}
    `}
`;

export const BreakdownItems = styled.div<{ $isStickySummary?: boolean }>`
    display: flex;
    flex-direction: column;

    ${({ $isStickySummary }) =>
        $isStickySummary
            ? css`
                  gap: ${getPurpurSpacing('25')};
                  border-bottom: 1px solid ${getPurpurColor('borderWeak')};
                  padding-bottom: ${getPurpurSpacing('100')};
                  margin-bottom: ${getPurpurSpacing('100')};

                  ${purpurMedia('lg')`
                    border-bottom: none;
                    border-right: 1px solid ${getPurpurColor('borderWeak')};
                    padding-bottom: 0;
                    margin-bottom: 0;
                    padding-right: ${getPurpurSpacing('300')};
                    margin-right: ${getPurpurSpacing('300')};
                  `}
              `
            : css`
                  gap: ${getPurpurSpacing('50')};
                  border-bottom: 1px solid ${getPurpurColor('borderWeak')};
                  padding-bottom: ${getPurpurSpacing('150')};
                  margin-bottom: ${getPurpurSpacing('150')};
              `}
`;

export const PriceBlockWrapper = styled.div<{ $isLarge?: boolean; $isStickySummary?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: ${({ $isLarge }) => getPurpurTypography($isLarge ? 'lineHeightDefault' : 'lineHeightLoose')};
    font-weight: ${({ $isLarge }) => getPurpurTypography($isLarge ? 'weightBold' : 'weightNormal')};
    gap: ${getPurpurSpacing('100')};

    ${({ $isStickySummary, $isLarge }) => {
        const fontSizeMobile =
            ($isStickySummary && $isLarge && 'scale100') ||
            ($isStickySummary && 'scale75') ||
            ($isLarge && 'scale200') ||
            'scale100';
        const fontSizeDesktop =
            ($isStickySummary && $isLarge && 'scale200') ||
            ($isStickySummary && 'scale75') ||
            ($isLarge && 'scale400') ||
            'scale100';

        return css`
            font-size: ${getPurpurTypography(fontSizeMobile)};

            ${purpurMedia('lg')`
                font-size: ${getPurpurTypography(fontSizeDesktop)};
            `}
        `;
    }}
`;

export const PriceBlockSlot = styled(CssTransition)`
    font-weight: unset;
`;
